<!-- <div class="container" fxLayout="row" fxLayoutAlign="space-between center">
  <div *ngIf="item && item.cells" class="grid-cell-ellipsis"
       matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
    {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
  </div>
  <div fxLayout="row" *ngIf="item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].value!=='N/A'">
    <button (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
      <mat-icon>create</mat-icon>
    </button>
  </div>
</div> -->

<div class="cbc-required">
  <div class="cbc-required-interactions">
    <div *ngIf="item && item.cells" class="cbc-required-display-text"
         matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
      {{this.item?.cells[this.fieldDefinition.key]?.displayText ? this.item?.cells[this.fieldDefinition.key]?.displayText : ''}}
    </div>
    <div class="cbc-interactions flex flex-row">
      <div class="file-voluntarily"
           *ngIf="this.item?.cells[fieldDefinitionKeyModel]?.value?.IsShowFileVoluntarily"
           (click)="onClicked('FileVoluntarily')">
        <span>file voluntarily</span>
      </div>
      <button *ngIf="this.item?.cells[fieldDefinitionKeyModel]?.value?.IsCbcRequiredOverwritten"
              (click)="onClicked('Refresh')"
              mat-icon-button class="reset-icon-dropdown-button">
        <mat-icon>cached</mat-icon>
      </button>
      <button (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
        <mat-icon>create</mat-icon>
      </button>
    </div>
  </div>
  <div class="cbc-required-footnote" *ngIf="this.item?.cells[fieldDefinitionKeyModel]?.value?.HasValueInJT110"
       matTooltip="{{this.item?.cells[fieldDefinitionKeyModel]?.value?.MiniNote ? this.item?.cells[fieldDefinitionKeyModel]?.value?.MiniNote : ''}}">
    {{this.item?.cells[fieldDefinitionKeyModel]?.value?.MiniNote}}
  </div>

  <Button *ngIf="this.item?.cells[fieldDefinitionKeyModel]?.value?.HasValueInJT6JT38" class="note-cell-arrow"
          (click)="openNote()">
    <div class="arrow-left"></div>
  </Button>
</div>


